module.exports = __webpack_public_path__ + "media/images/carousel/metier-image-1-e59cfc22bc3c056b2158bdb56f18843b.jpg";